module.exports = "https://r.nearpod.com/assets/media/image/shopping-cart-590d1e0849b5928b5078400cc6f34ab5.svg";